export enum MediaPlayerStatus {
  Unloaded = 0,
  Paused,
  Loading,
  Playing,
  Ended,
  Error
}